import { Center, Container, Group, Image, Loader, Stack, Title } from "@mantine/core";
import logo from '../../images/logo.svg';
import { useEffect } from "react";
import { nprogress } from '@mantine/nprogress';
import { Translate } from "react-auto-translate";

export default function PageLoader() {

    useEffect(() => {
        nprogress.start();
        return () => {
            nprogress.complete();
        };
    }, []);

    return (
        <Container>
            <Center w="100%" h="100dvh">
                <Group>
                    <Stack justify="center" align="center">
                        <Image src={logo} h={70} w="auto" fit="contain" mb="xs" />
                        <Title size="sm" mb="xs">
                            <Translate>
                                Please wait while we setup the app ...
                            </Translate>
                        </Title>
                        <Loader color="blue" />
                    </Stack>
                </Group>
            </Center>
        </Container>
    )
}
